import EventHandler from "../../utils/dom/event-handler";
import SelectorEngine from "../../utils/dom/selector-engine";
import BaseComponent from "../BaseComponent";
import CarouselV2 from "../CarouselV2";
import Manipulator from "../../utils/dom/manipulator";
const NAME = 'HomePageHeroBanner';

const SLIDE_DELAY = 5000;

class HomePageHeroBanner extends BaseComponent {
	constructor(element, options) {
		super(element, options);
        this.maxSlides = 4;
        if(Manipulator.getDataAttribute(element, 'max-slides')) {
            this.maxSlides = Manipulator.getDataAttribute(element, 'max-slides');
        }
        if(element) {
            this.initCarouselV2();
        }
        this._forcePause = false;
        this._playButton = true;
        this.autoPlayHandlerBound = this.autoPlayHandler.bind(this);
        this.autoPauseHandlerBound = this.autoPauseHandler.bind(this);
	}

    set forcePause(value) {
        this._forcePause = value;
        this.playButton = !value;
        this.autoplay = !value;
    }

    get forcePause() {
        return this._forcePause;
    }

    get autoplay() {
        return this._autoplay;
    }

    set autoplay(value) {
        if(this.forcePause && value) {
            return;
        }
        if(!!value) {
            this._autoplay = {
                delay: SLIDE_DELAY,
                disableOnInteraction: false,
            }
        }
        this._autoplay = value;
        this.manageAutoplay();
    }

    static get NAME() {
		return NAME;
	}

    set playButton(value) {
        this._playButton = value;
        this.togglePlayButtons();
    }
    
    get playButton() {
        return this._playButton;
    }

    async initCarouselV2() {
        if(this._element) {
            this.forcePause = false;
            this.slides = document.querySelector('.swiper-hero-banner', this._element);
            this.slidesThumbnails = document.querySelector('.swiper-hero-banner-thumbnails', this._element);
            this.slideElements = SelectorEngine.find('.swiper-hero-banner-thumbnails .swiper-slide', this._element);
            this.animationEndHandlerBound = this.animationEndHandler.bind(this);

            this.swiperHeroBannerThumbnails = new CarouselV2(this.slidesThumbnails, { 
                isThumbnailCarousel: true, 
                showPagination: false,
                maxSlides: this.maxSlides,
            });
            
            this.swiperHeroBanner = CarouselV2.getOrCreateInstance(this.slides, { 
                thumbnailCarousel: this.swiperHeroBannerThumbnails?.swiperInstance, 
                loop: false,
                autoplay: false, 
                showPagination: false,
                slidesPerView: 1,
                slidesPerViewMd: 1,
                slidesPerViewXl: 1,
                effect: "fade",
                fadeEffect: {
                    crossFade: true,
                },
                centerInsufficientSlides: true,
                maxSlides: this.maxSlides,
            });

            this.swiperHeroBannerThumbnails.swiperInstance.on('click', () => {
                this.autoplay = false;
            });
            
            this.swiperHeroBannerThumbnails.swiperInstance.on('slideChange', () => {
                this.swiperHeroBanner.swiperInstance.slideTo(this.swiperHeroBannerThumbnails.swiperInstance.activeIndex);
                this.resetNonActiveProgressBars();
            });

            this.swiperHeroBanner.swiperInstance.on('slideChange', () => {
                if(this.swiperHeroBanner.swiperInstance.activeIndex !== this.swiperHeroBannerThumbnails.swiperInstance.activeIndex) {
                    this.swiperHeroBannerThumbnails.swiperInstance.slideTo(this.swiperHeroBanner.swiperInstance.activeIndex);
                }
                SelectorEngine.find('.lta-home-page-hero-banner__progress-bar', this._element).forEach(progressBar => {
                    progressBar.style.width = '0%';
                });
            });

            EventHandler.on(this.slides, 'click', '.js-lta-home-page-hero-banner-pause-button', (event) => {
                event.stopPropagation();
                this.forcePause = true;
                event.target.parentElement.querySelector('.js-lta-home-page-hero-banner-play-button').focus();
            });

            EventHandler.on(this.slides, 'click', '.js-lta-home-page-hero-banner-play-button', (event) => {
                event.stopPropagation();
                this.forcePause = false;
                event.target.parentElement.querySelector('.js-lta-home-page-hero-banner-pause-button').focus();
            });

            EventHandler.on(this.slides, 'keydown', '.js-lta-home-page-hero-banner-pause-button', (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    event.stopPropagation();
                    this.forcePause = true;
                    event.target.parentElement.querySelector('.js-lta-home-page-hero-banner-play-button').focus();
                  }
            });

            EventHandler.on(this.slides, 'keydown', '.js-lta-home-page-hero-banner-play-button', (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    event.stopPropagation();
                    this.forcePause = false;
                    event.target.parentElement.querySelector('.js-lta-home-page-hero-banner-pause-button').focus();
                }
            });

            this.manageAutoPlayPauseOnSlideElements();

            for(let i = 0; i < this.slideElements.length; i++ ) {
                const slideElement = this.slideElements[i];
                EventHandler.on(slideElement, 'keydown', (event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        const slideIndex = Array.from(event.currentTarget.parentNode.children).indexOf(event.currentTarget);
                        this.swiperHeroBannerThumbnails.swiperInstance.updateActiveIndex(slideIndex);
                    }
                });

                EventHandler.on(slideElement, 'click', (event) => {
                    // this.stats("Before Click");
                    const slideIndex = Array.from(event.currentTarget.parentNode.children).indexOf(event.currentTarget);
                    // console.log(`Slide Index: ${slideIndex}`);
                    this.swiperHeroBannerThumbnails.swiperInstance.updateActiveIndex(slideIndex);
                    this.forcePause = true;
                    // this.stats("After Click");
                });

                EventHandler.on(slideElement, 'mouseenter', (event) => {
                    const isActiveSlide = event.currentTarget.classList.contains('swiper-slide-thumb-active');
                    if(isActiveSlide) {
                        this.autoplay = false;
                    }
                });

                EventHandler.on(slideElement, 'mouseleave', (event) => {
                    this.autoplay = true;
                });
                
                slideElement.addEventListener('animationend', this.animationEndHandlerBound);
            }

            EventHandler.on(this.slides, 'click', '.lta-home-page-hero-banner__button', (event) => {
                event.stopPropagation();
            });

            EventHandler.on(this.slides, 'click', '.js-lta-home-page-hero-banner-play-button', (event) => {
                event.stopPropagation();
            });

            EventHandler.on(this._element, 'click', '.lta-home-page-hero-banner__container', (event) => {
                const url = Manipulator.getDataAttribute(event.delegateTarget, 'url');
                this.redirectToUrl(url);
            });

        }
        this.autoplay = true;
    }

    autoPlayHandler() {
        this.autoplay = true;
    }

    autoPauseHandler() {
        this.autoplay = false;
    }
    
    redirectToUrl(url) {
        if(url && !event.target.classList.contains('lta-home-page-hero-banner__action-button')) {
            window.location.href = url;
        }
    }

    playAnimation() {
        if(!this.swiperHeroBannerThumbnails) {
            return;
        }

        this.slidesThumbnails.classList.add('autoplay-on');
        this.slidesThumbnails.classList.remove('pause');
        this.slidesThumbnails.classList.remove('autoplay-off');
    }

    pauseAnimation() {
        if(!this.swiperHeroBannerThumbnails) {
            return;
        }
        clearInterval(this.interval);
        this.slidesThumbnails.classList.add('pause');
    }

    togglePlayButtons() {
        if(this.playButton) {
            SelectorEngine.find('.js-lta-home-page-hero-banner-play-button', this._element).forEach(button => {
                button.classList.add('u-hidden');
            });
            SelectorEngine.find('.js-lta-home-page-hero-banner-pause-button', this._element).forEach(button => {
                button.classList.remove('u-hidden');
            });
        } else {
            SelectorEngine.find('.js-lta-home-page-hero-banner-play-button', this._element).forEach(button => {
                button.classList.remove('u-hidden');
            });
            SelectorEngine.find('.js-lta-home-page-hero-banner-pause-button', this._element).forEach(button => {
                button.classList.add('u-hidden');
            });
        }
    }

    manageAutoplay() {
        this.resetNonActiveProgressBars();
        if(this.autoplay) {
            this.playAnimation();
        } else {
            this.pauseAnimation();
        }
        this.togglePlayButtons();
    }

    resetNonActiveProgressBars() {
        SelectorEngine.find(':not(.swiper-slide-active) .lta-home-page-hero-banner__progress-bar', this._element).forEach(progressBar => {
            progressBar.style.width = '0%';
        });
    }   
    
    animationEndHandler = () => {
        // this.stats("Animation End");
        const totalSlides = this.swiperHeroBannerThumbnails.swiperInstance.slides.length;
        const activeIndex = this.swiperHeroBannerThumbnails.swiperInstance.activeIndex;
        const isLastSlide = this.swiperHeroBannerThumbnails.swiperInstance.activeIndex === totalSlides - 1;
        const nextIndex = isLastSlide ? 0 : activeIndex + 1;
        
        if(isLastSlide) {
            this.swiperHeroBannerThumbnails.swiperInstance.updateActiveIndex(0);
        } else {
            this.swiperHeroBannerThumbnails.swiperInstance.updateActiveIndex(nextIndex);
        }
        const translate = this.swiperHeroBannerThumbnails.swiperInstance.snapGrid[this.swiperHeroBannerThumbnails.swiperInstance.activeIndex];
        const speed = this.swiperHeroBannerThumbnails.swiperInstance.params.speed;
        this.swiperHeroBannerThumbnails.swiperInstance.translateTo(-translate, speed, () => {}, false);
    }
    
    manageAutoPlayPauseOnSlideElements() {
        const mainSlideElements = SelectorEngine.find('.lta-home-page-hero-banner__title, .lta-home-page-hero-banner__button', this._element);
        for(let i = 0; i < mainSlideElements.length; i++ ) {
            const mainSlideElement = mainSlideElements[i];
            EventHandler.off(mainSlideElement, 'mouseenter', this.autoPauseHandlerBound);
            EventHandler.on(mainSlideElement, 'mouseenter', this.autoPauseHandlerBound);
            EventHandler.off(mainSlideElement, 'mouseleave', this.autoPlayHandlerBound);
            EventHandler.on(mainSlideElement, 'mouseleave', this.autoPlayHandlerBound);
        }
    }

    manageAnimationEndHandlerOnSlideElements() {
        const slideElements = SelectorEngine.find('.swiper-hero-banner-thumbnails .swiper-slide', this._element);
        for(let i = 0; i < slideElements.length; i++ ) {
            const slideElement = slideElements[i];
            slideElement.removeEventListener('animationend', this.animationEndHandlerBound);
            slideElement.addEventListener('animationend', this.animationEndHandlerBound);
        }
    }
    
    restart() {
        this.autoplay = false;
        // this.swiperHeroBannerThumbnails.swiperInstance.slideNext();
        if(this.swiperHeroBanner) {
            this.swiperHeroBanner.update();
        }
        if(this.swiperHeroBannerThumbnails) {
            this.swiperHeroBannerThumbnails.update();
        }

        this.manageAnimationEndHandlerOnSlideElements();
        this.manageAutoPlayPauseOnSlideElements();

        // This is a workaround to fix the issue with the thumbnails not updating correctly
        this.swiperHeroBannerThumbnails.swiperInstance.updateActiveIndex(1);
        // End of workaround
        
        this.swiperHeroBannerThumbnails.swiperInstance.updateActiveIndex(0);
        const speed = this.swiperHeroBannerThumbnails.swiperInstance.params.speed;
        this.swiperHeroBannerThumbnails.swiperInstance.translateTo(0, speed, () => {}, false);
        this.autoplay = true;
    }

    stats(message) {
        console.log(`========================================`);
        console.log(`Stats - Message: ${message}`);
        const totalSlides = this.swiperHeroBannerThumbnails.swiperInstance.slides.length;
        const activeIndex = this.swiperHeroBannerThumbnails.swiperInstance.activeIndex;
        const isLastSlide = this.swiperHeroBannerThumbnails.swiperInstance.activeIndex === totalSlides - 1;
        const nextIndex = isLastSlide ? 0 : activeIndex + 1;
        console.log(`Stats - ActiveIndex: ${activeIndex}, NextIndex: ${nextIndex}, IsLastSlide: ${isLastSlide}, TotalSlides: ${totalSlides}`);
        console.log(`========================================`);
    }
}

export default HomePageHeroBanner;
